import './modal.scss'

import { FC } from 'react'
import { Modal as RBModal } from 'react-bootstrap'
import { modal_t } from 'src/types'
import { Header } from 'src/widgets'

export const Modal: FC<modal_t> = ({
  visible,
  children,
  on_close,
  classes = 'd-block',
  classes_child = 'modal-child',
}: modal_t) => {
  return (
    <RBModal onHide={() => undefined} show={visible} animation={false}>
      <div className="modal-height">
        <Header on_close={on_close} />
        <RBModal.Body className={classes_child}>
          <div className={classes}>{children}</div>
        </RBModal.Body>
      </div>
    </RBModal>
  )
}
